<template>
  <div class="itens-envio-checklist">
    <div
      v-for="item in itens"
      :key="item.key"
      class="itens-envio-checklist__item"
      :class="{ 'itens-envio-checklist__item--disabled': !item.available }"
    >
      <b-form-checkbox
        :checked="isSelecionado(item.key)"
        :disabled="disabled || !item.available"
        @change="alterar(item.key, $event)"
      >
        <span class="font-weight-bold">{{ item.label }}</span>
      </b-form-checkbox>
      <small class="text-muted d-block ml-7">
        {{ item.description }}
      </small>
    </div>

    <small v-if="error" class="text-danger d-block mt-2">{{ error }}</small>
  </div>
</template>

<script>
export default {
  name: "EnvioContabilidadeItensEnvioChecklist",
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    itens: {
      type: Array,
      default: () => [],
    },
    error: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    isSelecionado(key) {
      return Boolean(this.value && this.value[key]);
    },
    alterar(key, checked) {
      this.$emit("input", {
        ...(this.value || {}),
        [key]: Boolean(checked),
      });
    },
  },
};
</script>

<style scoped>
.itens-envio-checklist {
  border: 1px solid #ebedf3;
  border-radius: 6px;
  padding: 0.75rem;
}

.itens-envio-checklist__item + .itens-envio-checklist__item {
  border-top: 1px solid #f3f6f9;
  margin-top: 0.65rem;
  padding-top: 0.65rem;
}

.itens-envio-checklist__item--disabled {
  opacity: 0.72;
}
</style>
